import { composeTheme } from './composeTheme'
import { coreTheme } from './coreTheme'
import { vantageThemeOverlay } from './vantageThemeOverlay'

/**
 * The default Vantage theme, composed from `coreTheme` and `vantageThemeOverlay`.
 *
 * This is the theme that should be used by all Vantage components and treated as the canonical
 * source of truth for Vantage's brand styles.
 */
export const vantageTheme = composeTheme(coreTheme, vantageThemeOverlay)
